import { Reducer } from 'redux'
export interface Filter {
  pillarId?: string[]
  status?: string[]
  questionId?: string[]
  bestPracticeId?: string[]
  awsAccountId?: string[]
  region?: string[]

  subSectionIds?: string[]
  questionIdRefs?: string[]
  sectionIds?: string[]
  sectionPillarId?: string[]
}

export type PillarKeys =
  | 'partnerHosted'
  | 'supportLevel'
  | 'architectureReview'
  | 'alternateReviewProcessAwsWellArchitectedReview'
  | 'awsRootAccount'
  | 'communicationsFromAws'
  | 'identityAndAccessManagement'
  | 'operationalSecurity'
  | 'networkSecurity'
  | 'backupsAndRecovery'
  | 'resiliency'
  | 'amazonS3BucketAccess'
  | 'crossAccountAccess'
  | 'sensitiveData'
  | 'regulatoryComplianceAndValidationProcess'

export interface ChecksSummary {
  assessmentId: string
  totalChecks: string
  passedChecks: string
  failedChecks: string
  pillars: Record<PillarKeys, string>
  isCompleted: string
  totalFailedFindings?: number
}

export interface Findings {
  id: string
  assessmentId: string
  assessmentRegisterId: string
  awsAccountRole: string
  awsAccountId: string
  accountName: string
  bestPracticeId: string
  bestPractice: string
  checkId: string
  checkName: string
  checkTitle: string
  description: string
  details: string
  error: string
  partnerId: string
  pillarId: string
  sectionId: string
  sectionName: string
  questionId: string
  questionIdRef: string
  questionText: string
  questionCode: string
  question: string
  region: string
  status: boolean | string
  resourceId: string
  failedChecks: string // change to number if API guarantees numeric
  passedChecks: string // same here
  isMaster: boolean
  subSectionId: string
  subSectionTitle: string
}

export enum PillarWorkloadActionType {
  SET_WORKLOAD_DETAILS = 'SET_WORKLOAD_DETAILS',
  CLEAR_WORKLOAD_DETAILS = 'CLEAR_WORKLOAD_DETAILS',
  SET_CHECKS_FINDINGS = 'SET_CHECKS_FINDINGS',
  CLEAR_CHECKS_FINDINGS = 'CLEAR_CHECKS_FINDINGS',
  CLEAR_FINDINGS = 'CLEAR_FINDINGS',
  SET_FINDINGS = 'SET_FINDINGS',
  SET_FILTER = 'SET_FILTER',
  CLEAR_FILTER = 'CLEAR_FILTER',
  SET_TOKEN = 'SET_TOKEN',
  SET_TOTAL = 'SET_TOTAL',
  CLEAR_TOTAL = 'CLEAR_TOTAL',
}

export interface FTRFindingsState {
  findings: Findings[]
  nextToken: string
  totalFindings: number
  filter: Filter | null
  checksSummary: ChecksSummary | null
}

const initialState: FTRFindingsState = {
  findings: [],
  nextToken: '',
  totalFindings: 0,
  filter: {},
  checksSummary: null,
}

type actionType =
  | {
      type: PillarWorkloadActionType.CLEAR_FINDINGS
    }
  | {
      type: PillarWorkloadActionType.SET_FINDINGS
      payload: {
        findings: Findings[]
        paginationToken?: string
      }
    }
  | {
      type: PillarWorkloadActionType.SET_CHECKS_FINDINGS
      payload: ChecksSummary
    }
  | {
      type: PillarWorkloadActionType.SET_FILTER
      payload: Filter
    }
  | {
      type: PillarWorkloadActionType.CLEAR_FILTER
    }
  | {
      type: PillarWorkloadActionType.SET_TOKEN
      payload: string
    }
  | {
      type: PillarWorkloadActionType.CLEAR_CHECKS_FINDINGS
    }
  | {
      type: PillarWorkloadActionType.SET_TOTAL
      payload: number
    }
  | {
      type: PillarWorkloadActionType.CLEAR_TOTAL
    }

export const reducer: Reducer<FTRFindingsState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case PillarWorkloadActionType.SET_FINDINGS:
      return {
        ...state,
        findings: action.payload.paginationToken
          ? [...state.findings, ...action.payload.findings]
          : action.payload.findings,
      }
    case PillarWorkloadActionType.SET_CHECKS_FINDINGS:
      return {
        ...state,
        checksSummary: action.payload,
      }
    case PillarWorkloadActionType.SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      }
    case PillarWorkloadActionType.CLEAR_FILTER:
      return {
        ...state,
        filter: {},
      }
    case PillarWorkloadActionType.SET_TOKEN:
      return {
        ...state,
        nextToken: action.payload,
      }
    case PillarWorkloadActionType.CLEAR_FINDINGS:
      return {
        ...state,
        findings: [],
      }
    case PillarWorkloadActionType.CLEAR_CHECKS_FINDINGS:
      return {
        ...state,
        checksSummary: null,
      }
    case PillarWorkloadActionType.SET_TOTAL:
      return {
        ...state,
        totalFindings: action.payload,
      }
    case PillarWorkloadActionType.CLEAR_TOTAL:
      return {
        ...state,
        totalFindings: 0,
      }

    default:
      return state
  }
}
